import React from 'react';
import { Checkbox } from 'antd';
import {
  CheckBoxList,
  StyledCheckBox,
  MetricDivider,
  StyledText,
  CheckboxWrapper,
  CategoryWrapper,
} from '../styled';

const CheckboxGroup = ({
  categoryKey,
  listCategory,
  inputList = [],
  onChange,
  setRef,
  emptyText,
}) => {
  const category = listCategory[categoryKey];
  const emptyList = inputList.length === 0;

  function getCheckboxGroup() {
    if (emptyList) {
      return emptyText ?? <>No data</>;
    }
    return (
      <CheckboxWrapper count={inputList.length}>
        {inputList.map((c: any) => {
          return (
            <StyledCheckBox key={c.key} title={c.name}>
              <Checkbox
                onChange={onChange}
                checked={c.checked}
                disabled={c.disabled}
                value={c.key}
                key={c.key}
              >
                {c.name}
              </Checkbox>
            </StyledCheckBox>
          );
        })}
      </CheckboxWrapper>
    );
  }

  return (
    <CheckBoxList key={categoryKey} ref={setRef}>
      <CategoryWrapper>
        <StyledText>{category.displayName || categoryKey}</StyledText>
      </CategoryWrapper>
      <MetricDivider />
      {getCheckboxGroup()}
    </CheckBoxList>
  );
};

export default CheckboxGroup;
